export const ShiftCancellationReasonTypes = {
  ADMIN_EDIT_SHIFT: "ADMIN_EDIT_SHIFT",
  ADMIN_MIGRATION: "ADMIN_MIGRATION",
  BABYSITTER_ISSUE: "BABYSITTER_ISSUE",
  CAR_BROKE_DOWN: "CAR_BROKE_DOWN",
  COVID_SYMPTOMS_DURING_SHIFT: "COVID_SYMPTOMS_DURING_SHIFT",
  DISPLAYING_COVID_SYMPTOMS: "DISPLAYING_COVID_SYMPTOMS",
  DNR_ADDED: "DNR_ADDED",
  HCPS_STAGE_CHANGED: "HCPS_STAGE_CHANGED",
  FACILITY_ASKING_SWITCH_SHIFTS: "FACILITY_ASKING_SWITCH_SHIFTS",
  FACILITY_CANCELLED_SHIFTS: "FACILITY_CANCELLED_SHIFTS",
  FACILITY_COVID_STATUS_NOT_UPDATED: "FACILITY_COVID+_STATUS_NOT_UPDATED",
  FACILITY_COVID_STATUS: "FACILITY_COVID+_STATUS",
  FACILITY_ISSUE: "FACILITY_ISSUE",
  FACILITY_SUSPEND: "FACILITY_SUSPEND",
  FACILITY_REPORTED_NCNS: "FACILITY_REPORTED_NCNS",
  FEELING_ILL_DURING_SHIFT: "FEELING_ILL_DURING_SHIFT",
  LOW_CENSUS: "LOW_CENSUS",
  NO_CAR_FOR_SHIFT: "NO_CAR_FOR_SHIFT",
  NONE: "NONE",
  OTHER: "OTHER",
  PAYMENT_ISSUE: "PAYMENT_ISSUE",
  POPUP_CANCEL: "POPUP_CANCEL",
  SENT_HOME_BY_FACILITY: "SENT_HOME_BY_FACILITY",
  SICK_OTHER_ILLNESS: "SICK_OTHER_ILLNESS",
  SICK: "SICK",
  STAFFED_IN_HOUSE: "STAFFED_IN_HOUSE",
  STAFFED_OTHER_REGISTRY: "STAFFED_OTHER_REGISTRY",
  STAGE_CHANGED: "STAGE_CHANGED",
  SWITCHING_SHIFTS: "SWITCHING_SHIFTS",
  SYSTEM_EDIT_SHIFT: "SYSTEM_EDIT_SHIFT",
  TESTED_COVID_AT_FACILITY: "TESTED_COVID+_AT_FACILITY",
  TESTED_COVID: "TESTED_COVID+",
  TRANSPORTATION: "TRANSPORTATION",
  NOT_ON_SCHEDULE: "NOT_ON_SCHEDULE",
  FACILITY_USER_SUBMIT_SENT_HOME: "FACILITY_USER_SUBMIT_SENT_HOME",
  WORKER_IS_LATE: "WORKER_IS_LATE",
  WORKPLACE_TIME_EDIT: "WORKPLACE_TIME_EDIT",
  DELETE_AUTO_ASSIGN_SHIFT: "DELETE_AUTO_ASSIGN_SHIFT",
  HCP_CANCELLED_REMAINING_BLOCK: "HCP_CANCELLED_REMAINING_BLOCK",
  FACILITY_CANCELLED_REMAINING_BLOCK: "FACILITY_CANCELLED_REMAINING_BLOCK",
  REPLACED_URGENT_SHIFTS: "REPLACED_URGENT_SHIFTS",
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ShiftCancellationReasonTypes =
  (typeof ShiftCancellationReasonTypes)[keyof typeof ShiftCancellationReasonTypes];
